import { bifrost } from './lib/bifrost'
import { defineCustomClientStrategy } from './paraglide/runtime'
import { language } from './params'
import { native } from './services/native'

defineCustomClientStrategy('custom-queryParam', {
  getLocale: () => language,
  setLocale: () => {},
})

bifrost.registerService('GeneralService', {
  pageVisible: () => {},

  setSafeAreaInsets: (payload: {
    top: number
    right: number
    bottom: number
    left: number
  }) => {
    Object.entries(payload).forEach(([key, value]) => {
      document.documentElement.style.setProperty(
        `--safe-area-${key}`,
        `${Math.round(value as number)}px`,
      )
    })
  },
})

bifrost.initialize()

native.general.pageReady()
